import React from "react";
import { Box, MenuItem, Select } from "@mui/material";
import SelectArrow from "../../../styles/icons/SelectArrow";

const COLOR_HEADER = "#1E1E1E";
const COLOR_ACCENT = "#0DA3E2";

export default function TriggerModeHeaderControl({ value, onChange }) {
  return (
    <Box sx={{ minWidth: 250 }}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={SelectArrow}
        sx={{
          width: "100%",
          height: 44,
          color: "#FFFFFF",
          bgcolor: COLOR_HEADER,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: COLOR_ACCENT,
            borderRadius: "7px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: COLOR_ACCENT,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: COLOR_ACCENT,
          },
          "& .MuiSelect-icon": {
            top: "50%",
            transform: "translateY(-50%)",
          },
        }}
      >
        <MenuItem value="regular">Run Automatically</MenuItem>
        <MenuItem value="api">Wait For External Trigger</MenuItem>
      </Select>
    </Box>
  );
}
